export const SEARCH_HISTORY_KEY = 'keywords';
const getStorageKey = key => `wps_help_center_storage_${key}`;
export const USERINFO_KEY = getStorageKey('userInfo');
export const TEST_ORIGIN = 'https://academy-test.wps.com';
export const PROD_ORIGIN = 'https://www.wps.com';
export const HELP_TEST_ORIGIN = 'https://activity-us-test.4wps.net';
export const HELP_PROD_ORIGIN = 'https://activity.wps.com';
export const HELP_CENTER_EXPAND = getStorageKey('expand');
export const FEEDBACK_SUBMITED_KEY = getStorageKey('feedbackSubmited');
export const TOP_CATE_MAP = {
  doc: 'writer',
  xls: 'et',
  ppt: 'ppt',
  wps: 'wps',
  pdf: 'pdf'
};

export const EVALUATION_OPTIONS = [
  "Didn't match my interface",
  'Too technical or incomprehensible',
  'Incorrect operation instructions',
  'Incomplete instructions on this function',
  'Other'
];



// WEBPACK FOOTER //
// ./src/common/constant.js